import React, { Component } from 'react';
import moment from 'moment';

import CheckingParkingModel from './CheckingParkingModel';
import AutoZoneDetectionsModel from './AutoZoneDetectionsModel';
import CheckingNumberOfOffenses from './CheckingNumberOfOffenses';
import CheckingOffensesModel from './CheckingOffensesModel';
import CheckingOffenseForm from './CheckingOffenseForm';
import CheckingParkingTable from './CheckingParkingTable';
import CheckingOffensesTableExpander from './CheckingOffensesTableExpander';
import UserModel from './UserModel';

import { Table, Row, Col, Badge, Modal, Popconfirm, Typography, Divider, Card, message } from 'antd';

import { dateRenderer, dateSorter } from './Helpers';

class CheckingOffensesTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    statusDetail: {
      showed: false,
      data: null
    },
    checkingOffenseFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <CheckingOffensesTableExpander recordId={record.id} />
      </div>
    );
  }

  onShowStatusDetail(record) {
    let statusDetail = this.state.statusDetail;
    statusDetail.showed = true;
    this.setState({
      statusDetail
    });

    statusDetail.parkinglocation = record.locationId;
    statusDetail.licenceplate = record.plate.slice(-4);
    statusDetail.timestamp = record.timestamp;
    statusDetail.plate = record.plate;

    CheckingParkingModel.getAll(
      statusDetail.parkinglocation,
      statusDetail.licenceplate,
      statusDetail.timestamp)
      .then(data => {
        statusDetail.data = data
        this.setState({
          statusDetail
        });
      })
      .catch(err => {
        message.warning('Pakovací oprávnění se nepodařilo načíst!');
        statusDetail.data = [];
        this.setState({
          statusDetail
        });
      });
  }

  onShowZoneDetectionDetail(record) {
    let zoneDetectionDetail = this.state.zoneDetectionDetail;
    zoneDetectionDetail.showed = true;
    this.setState({
      zoneDetectionDetail
    });

    zoneDetectionDetail.parkinglocation = record.ParkingLocationID;
    zoneDetectionDetail.timestamp = record.Timestamp;

    AutoZoneDetectionsModel.getLastByParkinglocationAndTimestamp(
      zoneDetectionDetail.parkinglocation,
      zoneDetectionDetail.timestamp)
      .then(data => {
        zoneDetectionDetail.data = data
        this.setState({
          zoneDetectionDetail
        });
      });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'locationCodeName',
      key: 'locationCodeName',
    }, {
      title: 'Reg. značka',
      dataIndex: 'plate',
      key: 'plate',
      render: (text, record) => {
        return <CheckingNumberOfOffenses record={record} />;
      }
    }, {
      title: 'Čas zachycení',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 230,
      render: (text, record) => (
        <span>{text ? moment(text).format('LLLL') : null}</span>
      ),
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
    }, {
      title: 'Stav kontroly',
      dataIndex: 'offenseStatus',
      key: 'offenseStatus',
      filters: [
        { text: 'Probíhá kontrola', value: 0 },
        { text: 'Částečná shoda', value: 1 },
        { text: 'Možný přestupek', value: 2 }
      ],
      render: (text, record) => {
        if (text === 0) {
          return <Badge status="processing" text="Probíhá kontrola" />
        } else if (text === 1) {
          return (
            <a onClick={(e) => {
              e.preventDefault();
              this.onShowStatusDetail(record);
            }}>
              <Badge status="warning" text="Částečná shoda" />
            </a>
          )
        } else if (text === 2) {
          return (
            <a onClick={(e) => {
              e.preventDefault();
              this.onShowStatusDetail(record);
            }}>
              <Badge status="error" text="Možný přestupek" />
            </a>
          )
        }
      },
      filteredValue: filteredInfo.Status || null,
      onFilter: (value, record) => { return (record.Status == value) ? true : false }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CHECKER_OFFENSES_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                e.preventDefault();
                if (this.props.onGroupedBy !== undefined) {
                  this.props.onGroupedBy(record);
                }
              }}>Seskupit</a>
              <Divider type="vertical" />
              <a onClick={async (e) => {
                e.preventDefault();
                try {
                  let offense = await CheckingOffensesModel.get(record.id);
                  let plateDetailImage = offense.attachments[1] !== undefined
                    ? offense.attachments[1]
                    : null;
                  this.setState({
                    checkingOffenseFormData: {
                      id: offense.id,
                      plate: offense.plate,
                      plateDetailImage: plateDetailImage                  
                    }
                  });
                } catch (err) {
                  message.error('Detail přestupku se nepodařilo načíst!');
                }                
              }}>Opravit</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow(record.id)
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        } else {
          return (
            <div>
              <a onClick={(e) => {
                e.preventDefault();
                if (this.props.onGroupedBy !== undefined) {
                  this.props.onGroupedBy(record);
                }
              }}>Seskupit</a>
            </div>
          );
        }
      }
    }];

    const rowSelection = {
      selectedRowKeys: this.props.selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.props.onRowSelectionChanged(selectedRowKeys, selectedRows);
      },
      getCheckboxProps: record => ({
        disabled: (
          record.offenseStatus < 1 || (
            this.props.firstSelectedItem !== null
            && (
              record.plate !== this.props.firstSelectedItem.plate
              || moment(record.timestamp).get('year') !== this.props.firstSelectedItem.date.get('year')
              || moment(record.timestamp).get('month') !== this.props.firstSelectedItem.date.get('month')
              || moment(record.timestamp).get('day') !== this.props.firstSelectedItem.date.get('day')
            )
          )
        )
      }),
      hideDefaultSelections: true
    };

    return (
      <div>
        <Table
          size='small'
          className='cstm-offenses-table'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          onChange={this.handleChange}
          rowSelection={rowSelection}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }} />
        <Modal
          width={920}
          title={this.state.statusDetail.plate
            ? 'Parkovací opravnění pro RZ '
            + this.state.statusDetail.plate
            + ' : '
            + this.state.statusDetail.licenceplate
            : 'Parkovací opravnění pro RZ '}
          visible={this.state.statusDetail.showed}
          onCancel={() => {
            let statusDetail = {
              showed: false,
              data: null
            };
            this.setState({ statusDetail });
          }}
          footer={<p></p>} >
          <CheckingParkingTable
            data={!this.state.statusDetail.data ? [] : this.state.statusDetail.data}
            loading={!this.state.statusDetail.data ? true : false}
            rowKey="plate"
          />
        </Modal>
        <CheckingOffenseForm
          type="modal"
          modalVisible={this.state.checkingOffenseFormData === null ? false : true}
          initialValues={this.state.checkingOffenseFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ checkingOffenseFormData: null });
          }}
          onSuccess={(form, values) => {
            let data = Object.assign({}, this.state.checkingOffenseFormData, values, { offenseStatus: 0 });
            CheckingOffensesModel.update(this.state.checkingOffenseFormData.id, data)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  checkingOffenseFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div >
    );
  }
}

export default CheckingOffensesTable;


// WEBPACK FOOTER //
// ./src/components/CheckingOffensesTable.js